const CloseButton = ({ onClick }) => {
  return (
    <button
      style={{
        position: "absolute",
        top: "14px",
        right: "14px",
        width: "28px",
        height: "28px",
        borderRadius: "999px",
        border: "none",
        background: "rgba(14, 20, 27, 0.06)",
        cursor: "pointer",
        zIndex: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "background-color .12s",
      }}
      onClick={() => onClick(false)}
      onMouseEnter={(e) =>
        (e.currentTarget.style.backgroundColor = "rgba(14, 20, 27, 0.12)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = "rgba(14, 20, 27, 0.06)")
      }
    >
      <svg
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="2"
          y1="22"
          x2="22"
          y2="2"
          stroke="#7A8490"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <line
          x1="2"
          y1="2"
          x2="22"
          y2="22"
          stroke="#7A8490"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};

export default CloseButton;
